













import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import viewerService from '@/model/services/viewer-service';
import LeftViewer from '@/views/MainViewer/LeftViewer/LeftViewer.vue';
import RightViewer from '@/views/MainViewer/RightViewer/RightViewer.vue';
import Breadcrumb from '@/components/molecules/Breadcrumb.vue';
import TitleBar from '@/TitleBar.vue';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
    'title-bar': TitleBar,
    'left-viewer': LeftViewer,
    'right-viewer': RightViewer,
    'breadcrumb': Breadcrumb
  }
})
export default class MainViewer extends Vue {
  /** Data **/
  private isPC: boolean = false;
  private isMobile: boolean = false;
  private scrollWait: number = 300;
  /** Computed **/
  get text() {
    return {
      loginpath: GlobalConstants.LOGIN.PATH
    };
  }
  /** Refs **/
  /** Methods **/
  private initFlg() {
    contentsModule.pushIsAside(!contentsModule.isAside);
  }

  private onResize() {
    contentsModule.pushInnerWidth(window.innerWidth);
    if (window.innerWidth < 1000 && !this.isPC) {
      this.isPC = true;
      this.isMobile = false;
      contentsModule.pushIsAside(false);
    } else if (window.innerWidth > 1000 && !this.isMobile) {
      this.isMobile = true;
      this.isPC = false;
      contentsModule.pushIsAside(true);
    }
  }

  private onScroll() {
    const func = _.debounce(() => {
      contentsModule.pushInnerYOffset(window.pageYOffset);
    }, this.scrollWait);
    func();
  }

  private onClickRoute() {
    contentsModule.pushIsAside(!contentsModule.isAside);
  }

  /** Watchers **/
  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

}
